import { render, staticRenderFns } from "./ProCardsContainer.vue?vue&type=template&id=4fa92d7a"
import script from "./ProCardsContainer.vue?vue&type=script&lang=js"
export * from "./ProCardsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports